export const PROPERTY_CATEGORY_TITLES: Record<string, string> = {
  '0': 'Grundstück',
  '8': 'Haus',
  '17': 'Zinshaus',
  '23': 'Gewerbe',
  '27': 'Wohnung',
  '35': 'Büro',
  '39': 'Geschäft',
  '47': 'Sonderobjekt',
  '59': 'Keller',
  '61': 'Parken',
  '91': 'Gastgewerbe',
  '95': 'Beherbergung',
  '100': 'Land-/Forstwirtschaft',
  '111': 'Zimmer',
};
